export default __webpack_public_path__ + "static/media/Ecommerce_Bee_Wines_Liquors.e9fed763.png";